import { css } from '@emotion/core'
import styled from '@emotion/styled'

import { palette, spacing, Text, typography } from 'main/ui'

export const InfoContainer = styled.div`
  margin-top: ${spacing.majorScale(2)}px;
  margin-bottom: ${spacing.majorScale(6)}px;
`

const infoTextStyles = css`
  color: ${palette.slate};
`

export const InfoLabel = styled(Text)`
  ${infoTextStyles}

  font-weight: ${typography.fontWeight.bold};
`

export const InfoText = styled(Text)(infoTextStyles)
